<script setup>
import { DialogDescription, useForwardProps } from "reka-ui";

const props = defineProps({
  asChild: { type: Boolean, default: false },
  as: { type: [String, Object], default: "p" },
});

const forwarded = useForwardProps(props);
</script>

<template>
  <DialogDescription v-bind="forwarded" class="dialog-description">
    <slot />
  </DialogDescription>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/typography";

.dialog-description {
  @include typography.small;

  margin: 6px 0 0;
  color: c.$text-subtle;
}
</style>
